import { action } from '@ember/object';
import { type Registry as Services, service } from '@ember/service';
import Component from '@glimmer/component';
import SettingsCentralMappingTablesCellsEditableNumberCell from 'lumen/components/settings/central-mapping/tables/cells/editable-number-cell';
import type { CentralMappingMappingEntryRoomType } from 'lumen/models';
import type { NumericValueKeysTypes } from 'lumen/utils/central-mapping-constants';

interface HotelSettingsCentralMappingTablesCellsTdNumberSignature {
  Args: {
    column: {
      isReadOnly?: boolean;
      maxValue: number;
      placeholder: string;
      tdNumberDataTestId: string;
      valueKey: NumericValueKeysTypes;
    };
    row: {
      mappingEntry: CentralMappingMappingEntryRoomType;
    };
    rowMeta: {
      isSelected: boolean;
    };
  };
}

export default class HotelSettingsCentralMappingTablesCellsTdNumber extends Component<HotelSettingsCentralMappingTablesCellsTdNumberSignature> {
  @service declare centralMapping: Services['central-mapping'];

  get isReadOnly(): boolean {
    return this.args.column.isReadOnly || Boolean(this.args.rowMeta.isSelected);
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get value() {
    const { row, column } = this.args;

    return row.mappingEntry[column.valueKey];
  }

  @action
  setValue(value: number | null): void {
    const { row, column } = this.args;
    const { mappingEntry } = row;
    mappingEntry[column.valueKey] = value;

    this.centralMapping.trackMappingEntryChanged({
      mappingChange: column.valueKey,
    });
  }

  <template>
    <SettingsCentralMappingTablesCellsEditableNumberCell
      @cellDataTestId={{@column.tdNumberDataTestId}}
      @isReadOnly={{this.isReadOnly}}
      @maxValue={{@column.maxValue}}
      @placeholder={{@column.placeholder}}
      @setValue={{this.setValue}}
      @value={{this.value}}
    />
  </template>
}
